export default {
  setLeads(state, payload) {
    state.leads = payload
  },

  setAtrasadas(state, payload) {
    state.atrasadas = payload
  },

  setVenceAmanha(state, payload) {
    state.venceAmanha = payload
  },

  setVenceHoje(state, payload) {
    state.venceHoje = payload
  }
}
